import * as React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import MUIDataTable from "mui-datatables";
import { filePDF } from "../../assets/pdf";
import Button from '@mui/material/Button';
import { useSelector } from "react-redux";
import { useDispatch, } from "react-redux";
import Checkbox from '@mui/material/Checkbox';
import {useHistory} from 'react-router-dom'
import { updateSocietiesSelected } from '../../Store/Ducks/duckSocieties';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from "@mui/styles";
import { getCountries,updateCountriesSelected } from "../../Store/Ducks/duckCountries";
import {snackAction} from '../../components/CustomSnakbar.jsx';
import { useSnackbar } from "notistack";
import {ROUTES} from '../../constants'
import { getURLToDownload } from '../../Store/Ducks/duckSocietiesTaxProfile';

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: "0px",
    marginBottom: "10px",
  },
  containerGrid: {
    backgroundColor: "white",
    padding: "20px",
    marginTop:"25px",
    width:"80%",
    marginLeft:"10%",
    // border:"solid 1px black",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.91)",  
  },
}));

export const SocietiesList = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { handleClickDownload, isDownload, societies, showAll } = props;
  const countries = useSelector(store => store.countries.data);
  const sortItems = (array) =>
  array.sort((a, b) => a.description.toUpperCase().localeCompare(b.description.toUpperCase()));

  const [societiesList, setSocietiesList] = React.useState(sortItems(societies))
  const [selectIds, setselectIds] = React.useState()
  
  const handleChangeSelected = (ids) => {
    let newList = selectIds;
    newList = newList.map((item)=>{
      if(ids.includes(item.id))
        item.selected=true;
      else
        item.selected=false;
        return item; 
    });

    dispatch(updateCountriesSelected(newList))
    // setSocietiesList(newList)
  }

  const handleClickUpdateSocieties = () => {
    let newList = societiesList.map((item)=>{
      if(selectIds.filter(x=>x.selected).map(x=>x.id).includes(item.countryId))
        item.selected=true;
      else
        item.selected=false;
        return item;
    });
    dispatch(updateSocietiesSelected(newList))
    enqueueSnackbar(`Datos actualizados`, { variant: "success", action: snackAction, autoHideDuration: 2000 });
    history.push(ROUTES.HOME)
  }

  const handleDownloadZip = (code) => {
    dispatch(getURLToDownload(code))
      .then((response) => {
        const url = response.payload.data;
        const link = document.createElement('a');
        link.href = url;
        link.download = 'archivo.zip'
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        if(error.response.status === 400){
          enqueueSnackbar(`Código de Sociedad incorrecto`, { variant: "warning", action: snackAction, autoHideDuration: 3000 });
        }
        if(error.response.status === 404){
          enqueueSnackbar(`Perfil impositivo no encontrado`, { variant: "warning", action: snackAction, autoHideDuration: 3000 });
        }
      })
  }

  const columnsDownload = [
    {
      name: "code",
      label: "Código Sociedad",
      options: {
        filter: true,
        display: true,
        setCellProps: () => ({ style: { textAlign: "center" } }),
      },
    },
    {
      name: "nif",
      label: "ID Fiscal",
      options: {
        display: true,
        filter: true,
      },
    },
    {
      name: "description",
      label: "Compañia",
      options: {
        filter: true,
        display: true,
      },
    },
    {
      name: "url",
      label: "Perfil Impositivo",
      options: {
        filter: false,
        sort: false,
        empty: true,
        viewColumns: false,
        customBodyRenderLite: (dataIndex) => {
          let rowData = societiesList[dataIndex];
          
           return (
            <div onClick={() => handleDownloadZip(rowData?.code)} >
              Descargar
            </div>
          );
        },
        setCellProps: () => ({ style: { width: 130, textAlign: "center", color: "green", cursor: "pointer" } }),
      },
    },
  ];

  const options = {
    filterType: "multiselect",
    expandableRowsHeader: false,
    selectableRows: "none",
    download: false,
    print: false,
    viewColumns: true,
    responsive: "standard",
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: "420px",
    jumpToPage: true,
  };
  React.useEffect(() => {
    if(countries.length===0)
      dispatch(getCountries())
}, [countries.length, dispatch])

React.useEffect(() => {
  if(countries.length>0)
    setselectIds(countries)
}, [countries, selectIds])

  return (        
          <MUIDataTable columns={columnsDownload} data={showAll ? societiesList : societiesList.filter(x => x.selected)} options={options} title={
          <>
          <span>
            {`Perfil Tributario  `}
          </span>
          <span style={{fontSize:"15px"}}>
          (Fecha Actualizacion: {filePDF.INFORMATION.PERFIL_TRIBUTARIO.INFORMATION_UPDATE_LAST})
          </span>
           </>
          } />
  );
}
